module.exports = __webpack_public_path__ + "img/btttom-logo.0fe1b7c4.png";